import React, { useState } from 'react'
import { Empty, Form as AntForm, Pagination, Skeleton } from 'antd'
import { Back, Container, DividerText, StyledDivider } from './Style'
import { useHistory } from 'react-router-dom'
import { IoReturnDownBack } from 'react-icons/io5'
import { Col, Divider, Row } from 'antd'
import { ModalContainer } from './Style'
import PostCard from '../../globalComponents/PostCard'
import { Label } from '../../globalComponents/globalStyle'
import { TextInput } from '../../globalComponents/TextInput'
import { Dropdown, StyledInput } from '../Post/style'
import { SubmitButton } from '../Services/Styles'
import { LoggerButton } from '../../globalComponents/Button'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { Option } from '../Onboard/Style'
import { ModalComponent } from '../../globalComponents/Modal'
import {
  handleAllPages,
  handleCurrentPage,
  handleSearchList,
  searchFeedReducer,
} from './slice'
import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import {
  FETCH_SEARCH_QUESTIONS,
  ASK_QUESTION,
  FETCH_TAGS,
} from '../../app/apollo'
import { NotificationAlert } from '../../utils/NotificationAlert'

const Search = () => {
  const history = useHistory()
  const [tagList, setTagList] = React.useState(['Oh my', 'holla', 'thanks'])
  const [loadingCreate, setLoadingCreate] = useState(false)
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [tags, setTags] = useState()
  const [newSearch, setNewSearch] = useState(false)
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = React.useState(false)

  const handleBackChange = () => {
    if (searchFeed?.currentPage > 1) {
      handleSearchQuestions(
        tags,
        title,
        description,
        searchFeed?.currentPage - 1,
      )
      handleCurrentPage(searchFeed?.currentPage - 1)
    }
  }
  const handleForwardChange = () => {
    if (searchFeed?.currentPage < searchFeed?.allPages) {
      handleSearchQuestions(
        tags,
        title,
        description,
        searchFeed?.currentPage + 1,
      )
      handleCurrentPage(searchFeed?.currentPage + 1)
    }
  }

  function itemRender(current?: any, type?: any, originalElement?: any) {
    if (type === 'prev') {
      return (
        <h5 style={{ color: 'blue', margin: 0 }} onClick={() => console}>
          Previous
        </h5>
      )
    }
    if (type === 'next') {
      return (
        <h5 style={{ color: 'blue', margin: 0 }} onClick={handleForwardChange}>
          Next
        </h5>
      )
    }
    return originalElement
  }
  const dispatcher = useAppDispatch()
  const searchFeed = useAppSelector(searchFeedReducer)

  const [searchQuestions, searchQuestionsData] = useLazyQuery(
    FETCH_SEARCH_QUESTIONS,
  )
  const { data: datatags, loading: loadingTags, error: errorTags } = useQuery(
    FETCH_TAGS,
  )
  const [askQuestion] = useMutation(ASK_QUESTION)
  React.useEffect(() => {
    if (searchQuestionsData?.error) {
      setLoading(false)
      NotificationAlert('error', 'Error occured', 'Try again')
    } else if (searchQuestionsData?.data?.searchQuestions) {
      setLoading(false)
      if (newSearch == false) {
        dispatcher(
          handleSearchList([
            ...searchFeed?.searchFeedList,
            ...searchQuestionsData?.data?.searchQuestions?.questions,
          ]),
        )
      } else if (newSearch == true) {
        // console.log('holla world')
        dispatcher(
          handleSearchList([
            ...searchQuestionsData?.data?.searchQuestions?.questions,
          ]),
        )
        setNewSearch(false)
      }

      dispatcher(
        handleCurrentPage(
          +searchQuestionsData?.data?.searchQuestions?.current_page,
        ),
      )
      dispatcher(
        handleAllPages(+searchQuestionsData?.data?.searchQuestions?.last_page),
      )
      console.log('searchData', searchQuestionsData)
    }
  }, [searchQuestionsData])

  const handleSearchQuestions = async (
    byTags: any,
    byTitle: any,
    byDescription: any,
    requestedPage: any,
  ) => {
    setLoading(true)
    if (newSearch === true) {
      dispatcher(handleSearchList(null))
    }
    try {
      await searchQuestions({
        variables: {
          byTags,
          byTitle,
          byDescription,
          requestedPage: +requestedPage,
          itemsPerPage: 15,
        },
      })
    } catch (e) {
      setLoading(false)
      console.log('search error', e)
    }
  }

  console.log('search feed ', searchFeed)

  const handleModal = (val: boolean) => {
    setModal(val)
  }
  const onFinish = async (value: any) => {
    setLoadingCreate(true)

    try {
      const response: any = await askQuestion({
        variables: {
          title: value.topic,
          description: value.description,
          tags: value.tag,
        },
      })
      if (response) {
        setLoadingCreate(false)
        console.log('create', response)
        if (response?.data?.askQuestion?.success) {
          NotificationAlert('success', 'Question created successfully')
          setModal(false)
        } else {
          NotificationAlert('error', 'Question not created')
        }
      }
    } catch (e) {
      setLoadingCreate(false)
      console.log('create feed error', e)
    }
  }
  return (
    <div style={{ width: '100%' }}>
      <ModalComponent onCancel={() => handleModal(false)} visible={modal}>
        <ModalContainer>
          <h3>Create a New Topic</h3>
          <br />
          <AntForm layout="vertical" onFinish={onFinish}>
            <AntForm.Item
              name="topic"
              rules={[
                {
                  required: true,
                  message: 'this field is required',
                },
              ]}
              label={
                <Label>
                  <h3>Topic</h3>
                </Label>
              }
            >
              <div>
                <TextInput type="text" required={true} name="topic" />
              </div>
            </AntForm.Item>
            <AntForm.Item
              name="description"
              rules={[
                {
                  required: true,
                  message: 'this field is required',
                },
              ]}
              label={
                <Label>
                  <h3>Description</h3>
                </Label>
              }
            >
              <div>
                <StyledInput
                  autoSize={{ minRows: 3, maxRows: 3 }}
                  required={true}
                  name="description"
                />
              </div>
            </AntForm.Item>
            <AntForm.Item
              name="tag"
              rules={[
                {
                  required: true,
                  message: 'this field is required',
                },
              ]}
              label={
                <Label>
                  <h3>Tag</h3>
                </Label>
              }
            >
              {/* <div> */}
              <Dropdown style={{ height: '100%' }} mode="multiple">
                {datatags?.allTagsAvailable?.map((tags: any, id: any) => (
                  <Option key={id} value={tags}>
                    {tags}
                  </Option>
                ))}
              </Dropdown>
              {/* </div> */}
            </AntForm.Item>
            <div style={{ width: 'fit-content', marginTop: '15px' }}>
              <LoggerButton
                htmlType="submit"
                loading={loadingCreate}
                text="Create Topic"
              />
            </div>
          </AntForm>
        </ModalContainer>
      </ModalComponent>
      <Container style={{ paddingRight: '10px' }}>
        <Back onClick={() => history.goBack()}>
          <IoReturnDownBack />
          <h2>back</h2>
        </Back>
        <br />
        <Row style={{ width: '100%' }} justify="space-between">
          <Col xs={{ span: 24 }} md={{ span: 7 }}>
            <>
              <Label>
                <h3 style={{ fontWeight: 400 }}>Topic</h3>
              </Label>
              <StyledInput
                onChange={(e) => setTitle(e.target?.value)}
                autoSize={{ minRows: 1, maxRows: 3 }}
                placeholder="Type topic for search..."
              />
            </>{' '}
            <br />
            <br />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 8 }}>
            <div>
              <Label>
                <h3 style={{ fontWeight: +400 }}>Description</h3>
              </Label>
              <StyledInput
                onChange={(e) => setDescription(e.target?.value)}
                autoSize={{ minRows: 1, maxRows: 3 }}
                placeholder="Type topic for search..."
              />
            </div>
            <br />
          </Col>

          <br />
          <Col xs={{ span: 24 }} md={{ span: 8 }}>
            <div>
              <Label>
                <h3 style={{ fontWeight: +400 }}>Select Tags</h3>
              </Label>
              <Dropdown
                // placeholder="Select appropriate tags"
                style={{ height: '100%' }}
                mode="multiple"
                onChange={(e: any) => setTags(e)}
              >
                {datatags?.allTagsAvailable?.map((tags: any, id: any) => (
                  <Option key={id} value={tags}>
                    {tags}
                  </Option>
                ))}
              </Dropdown>
            </div>
          </Col>
        </Row>
        <div
          style={{
            width: 'fit-content',
            marginLeft: 'auto',
            marginTop: '15px',
          }}
        >
          <LoggerButton
            loading={loading}
            text="Search"
            onClick={() => {
              handleSearchQuestions(tags, title, description, 1)
              setNewSearch(true)
            }}
          />
        </div>
        <br />
        {/* Search
        </Logger> */}
      </Container>
      <br />
      <div style={{ width: 'fit-content', marginTop: '15px' }}>
        <LoggerButton
          loading={false}
          text=" Start a New Topic"
          onClick={() => setModal(true)}
        />
      </div>
      <br />

      <Row style={{ width: '100%' }}>
        <Col xs={{ span: 24 }} md={{ span: 15 }}>
          <StyledDivider orientation="left">
            <DividerText>Search result</DividerText>
          </StyledDivider>
          {searchFeed?.searchFeedList?.length > 0 && (
            <>
              <PostCard posts={searchFeed?.searchFeedList} />
            </>
          )}
          {
            // searchFeed?.searchFeedList?.length &&
            loading && <Skeleton active />
          }
          {searchFeed?.searchFeedList?.length < 1 && !loading && <Empty />}
          {searchFeed?.searchFeedList?.length > 0 && (
            <Pagination
              style={{ marginBottom: '10vh' }}
              current={searchFeed?.currentPage}
              total={searchFeed?.allPages}
              pageSize={1}
              defaultPageSize={searchFeed?.allPages}
              showSizeChanger={false}
              itemRender={itemRender}
              showTotal={(total) => `Total: ${total} list`}
            />
          )}
          {/* <br />
          <StyledDivider orientation="left">
            <DividerText>Related search result</DividerText>
          </StyledDivider>
          <PostCard posts={searchFeed?.searchFeedList} /> */}
        </Col>
      </Row>
    </div>
  )
}

export default Search
